import { z } from 'zod';

export const CompleteCustomerVehicleRegistrationResponseSchema = z.object({
  customerVehicleId: z.uuid(),
});

export type CompleteCustomerVehicleRegistrationResponse = z.infer<
  typeof CompleteCustomerVehicleRegistrationResponseSchema
>;

export const DiscardCustomerVehicleDraftResponseSchema = z.object({
  customerVehicleId: z.uuid(),
});

export type DiscardCustomerVehicleDraftResponse = z.infer<
  typeof DiscardCustomerVehicleDraftResponseSchema
>;
